import React, { useRef } from 'react';
import IframeResizer from 'iframe-resizer-react';

import FrameOptions from '../FrameOptions';

const FiscalPage = (props) => {
  const ref = useRef(null);

  return (
    <>
      <IframeResizer
        id="fisc"
        // log
        forwardRef={ref}
        src={props.url}
        onMessage={ props.onMessage }
        inPageLinks
        { ...FrameOptions }
      />
    </>
  );
};

export default FiscalPage;
